import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useTranslation } from 'react-i18next';

// Luxembourg coordinates - 25, Rue Joseph Junck L-1839 Luxembourg
const RESTAURANT_COORDS = {
  lat: 49.60068290934538,
  lng: 6.131038237594128
};

// Google Maps URL for Fleur de Sel restaurant
const GOOGLE_MAPS_URL = 'https://www.google.com/maps/place/Fleur+De+Sel/@49.6006261,6.1308452,45m/data=!3m1!1e3!4m12!1m5!3m4!2zNDnCsDM2JzAyLjUiTiA2wrAwNyc1MS43IkU!8m2!3d49.6006829!4d6.1310382!3m5!1s0x479548d077ba097d:0xdaa4e5866534c5f8!8m2!3d49.6006199!4d6.1309616!16s%2Fg%2F11f5bw7_2y?entry=ttu';

// Function to open GPS/Maps navigation
const openInMaps = () => {
  window.open(GOOGLE_MAPS_URL, '_blank');
};

// Custom marker icon with click handler
const createCustomIcon = () => {
  return L.divIcon({
    className: 'custom-map-marker',
    html: `<img src="/img/map.png" alt="Fleur de Sel" style="cursor:pointer;" />`,
    iconAnchor: [25, 50],
  });
};

const Map = () => {
  const { t } = useTranslation();
  const position = [RESTAURANT_COORDS.lat, RESTAURANT_COORDS.lng];

  return (
    <div style={{ height: '100%', width: '100%', position: 'relative' }}>
      <MapContainer
        center={position}
        zoom={18}
        scrollWheelZoom={false}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker
          position={position}
          icon={createCustomIcon()}
          eventHandlers={{
            click: openInMaps
          }}
        />
      </MapContainer>

      {/* Hint label */}
      <div style={{
        position: 'absolute',
        bottom: '15px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'rgba(255,255,255,0.95)',
        padding: '8px 16px',
        borderRadius: '20px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        fontSize: '13px',
        fontWeight: '500',
        color: '#333',
        pointerEvents: 'none'
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7e7b5e" strokeWidth="2">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
          <circle cx="12" cy="10" r="3"/>
        </svg>
        {t('map.openDirections')}
      </div>
    </div>
  );
};

export default Map;
